/**
 * <dialog-drawer id="…"> wraps a native <dialog>. Any element with
 * data-drawer-open="<id>" opens it; [data-drawer-close] inside closes it;
 * clicking the backdrop closes it. Focus trap, Escape and focus return are
 * handled by the platform. Emits drawer:open / drawer:close (bubbling).
 */
class DialogDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    this.dialog.addEventListener('close', () => {
      this.trigger?.setAttribute('aria-expanded', 'false');
      this.dispatchEvent(new CustomEvent('drawer:close', { bubbles: true }));
    });
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-drawer-close]')) this.close();
    });
    document.querySelectorAll(`[data-drawer-open="${this.id}"]`).forEach((trigger) => {
      trigger.setAttribute('aria-controls', this.id);
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(trigger);
      });
    });
  }

  open(trigger) {
    if (!this.dialog || this.dialog.open) return;
    this.trigger = trigger;
    this.dialog.showModal();
    trigger?.setAttribute('aria-expanded', 'true');
    this.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
    const focusTarget = this.dialog.querySelector('[data-drawer-focus]');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  close() {
    if (!this.dialog || !this.dialog.open) return;
    this.dialog.close();
  }
}

if (!customElements.get('dialog-drawer')) customElements.define('dialog-drawer', DialogDrawer);
